import * as api from '../api/worktypes';
import { makeApiActionCreatorV3 } from '@actions/utils';
import {
  createRequestTypes,
  START,
  SUCCESS,
  ERROR,
} from '@modules/appraisal/actions/global';

const namespace = 'QUEUE';

export const FETCH_WORK_DEFINITIONS = createRequestTypes(
  `${namespace}/FETCH_WORK_DEFINITIONS`,
);

export const fetchDefinitions = makeApiActionCreatorV3(
  api.fetchDefinitions,
  FETCH_WORK_DEFINITIONS[START],
  FETCH_WORK_DEFINITIONS[SUCCESS],
  FETCH_WORK_DEFINITIONS[ERROR],
);

export const UPDATE_WORK_DEFINITION = createRequestTypes(
  `${namespace}/UPDATE_WORK_DEFINITION`,
);

export const updateDefinition = makeApiActionCreatorV3(
  api.updateDefinition,
  UPDATE_WORK_DEFINITION[START],
  UPDATE_WORK_DEFINITION[SUCCESS],
  UPDATE_WORK_DEFINITION[ERROR],
);

export const ADD_WORK_DEFINITION = createRequestTypes(
  `${namespace}/ADD_WORK_DEFINITION`,
);

export const addDefinition = makeApiActionCreatorV3(
  api.addDefinition,
  ADD_WORK_DEFINITION[START],
  ADD_WORK_DEFINITION[SUCCESS],
  ADD_WORK_DEFINITION[ERROR],
);

export const FETCH_WORK_DEFINITION = createRequestTypes(
  `${namespace}/FETCH_WORK_DEFINITION`,
);

export const fetchDefinition = makeApiActionCreatorV3(
  api.fetchDefinition,
  FETCH_WORK_DEFINITION[START],
  FETCH_WORK_DEFINITION[SUCCESS],
  FETCH_WORK_DEFINITION[ERROR],
);

export const DELETE_WORK_DEFINITION = createRequestTypes(
  `${namespace}/DELETE_WORK_DEFINITION`,
);

export const deleteDefinition = makeApiActionCreatorV3(
  api.deleteDefinition,
  DELETE_WORK_DEFINITION[START],
  DELETE_WORK_DEFINITION[SUCCESS],
  DELETE_WORK_DEFINITION[ERROR],
);

export const FETCH_SUBTYPES = createRequestTypes(`${namespace}/FETCH_SUBTYPES`);

export const fetchSubtypes = makeApiActionCreatorV3(
  api.fetchSubtypes,
  FETCH_SUBTYPES[START],
  FETCH_SUBTYPES[SUCCESS],
  FETCH_SUBTYPES[ERROR],
);
export const ADD_SUBTYPE = createRequestTypes(`${namespace}/ADD_SUBTYPE`);

export const addSubtype = makeApiActionCreatorV3(
  api.addSubtype,
  ADD_SUBTYPE[START],
  ADD_SUBTYPE[SUCCESS],
  ADD_SUBTYPE[ERROR],
);

export const FETCH_SUBTYPE = createRequestTypes(`${namespace}/FETCH_SUBTYPE`);

export const fetchSubtype = makeApiActionCreatorV3(
  api.fetchSubtype,
  FETCH_SUBTYPE[START],
  FETCH_SUBTYPE[SUCCESS],
  FETCH_SUBTYPE[ERROR],
);

export const DELETE_SUBTYPE = createRequestTypes(`${namespace}/DELETE_SUBTYPE`);

export const deleteSubtype = makeApiActionCreatorV3(
  api.deleteSubtype,
  DELETE_SUBTYPE[START],
  DELETE_SUBTYPE[SUCCESS],
  DELETE_SUBTYPE[ERROR],
);

export const UPDATE_SUBTYPE = createRequestTypes(`${namespace}/UPDATE_SUBTYPE`);

export const updateSubtype = makeApiActionCreatorV3(
  api.updateSubtype,
  UPDATE_SUBTYPE[START],
  UPDATE_SUBTYPE[SUCCESS],
  UPDATE_SUBTYPE[ERROR],
);

export const FETCH_STATUSES = createRequestTypes(`${namespace}/FETCH_STATUSES`);

export const fetchStatuses = makeApiActionCreatorV3(
  api.fetchStatuses,
  FETCH_STATUSES[START],
  FETCH_STATUSES[SUCCESS],
  FETCH_STATUSES[ERROR],
);
export const ADD_STATUS = createRequestTypes(`${namespace}/ADD_STATUS`);

export const addStatus = makeApiActionCreatorV3(
  api.addStatus,
  ADD_STATUS[START],
  ADD_STATUS[SUCCESS],
  ADD_STATUS[ERROR],
);

export const FETCH_STATUS = createRequestTypes(`${namespace}/FETCH_STATUS`);

export const fetchStatus = makeApiActionCreatorV3(
  api.fetchStatus,
  FETCH_STATUS[START],
  FETCH_STATUS[SUCCESS],
  FETCH_STATUS[ERROR],
);

export const DELETE_STATUS = createRequestTypes(`${namespace}/DELETE_STATUS`);

export const deleteStatus = makeApiActionCreatorV3(
  api.deleteStatus,
  DELETE_STATUS[START],
  DELETE_STATUS[SUCCESS],
  DELETE_STATUS[ERROR],
);

export const UPDATE_STATUS = createRequestTypes(`${namespace}/UPDATE_STATUS`);

export const updateStatus = makeApiActionCreatorV3(
  api.updateStatus,
  UPDATE_STATUS[START],
  UPDATE_STATUS[SUCCESS],
  UPDATE_STATUS[ERROR],
);

export const FETCH_WORK_TYPES_SUB_TYPES = createRequestTypes(
  `${namespace}/FETCH_WORK_TYPES_SUB_TYPES`,
);

export const fetchWorkTypesSubTypes = makeApiActionCreatorV3(
  api.fetchWorkTypesSubTypes,
  FETCH_WORK_TYPES_SUB_TYPES[START],
  FETCH_WORK_TYPES_SUB_TYPES[SUCCESS],
  FETCH_WORK_TYPES_SUB_TYPES[ERROR],
);

export const FETCH_WORK_TYPES_SUB_TYPES_STATUSES = createRequestTypes(
  `${namespace}/FETCH_WORK_TYPES_SUB_TYPES_STATUSES`,
);

export const fetchWorkTypesSubTypesStatuses = makeApiActionCreatorV3(
  api.fetchWorkTypesSubTypesStatuses,
  FETCH_WORK_TYPES_SUB_TYPES_STATUSES[START],
  FETCH_WORK_TYPES_SUB_TYPES_STATUSES[SUCCESS],
  FETCH_WORK_TYPES_SUB_TYPES_STATUSES[ERROR],
);

export const SET_DEFAULT_WORK_TYPE = createRequestTypes(
  `${namespace}/SET_DEFAULT_WORK_TYPE`,
);

export const setDefaultWorkType = makeApiActionCreatorV3(
  api.setDefaultWorkType,
  SET_DEFAULT_WORK_TYPE[START],
  SET_DEFAULT_WORK_TYPE[SUCCESS],
  SET_DEFAULT_WORK_TYPE[ERROR],
);

export const SET_STATUS_VISIBILITY = createRequestTypes(
  `${namespace}/SET_STATUS_VISIBILITY`,
);

export const setStatusVisibility = makeApiActionCreatorV3(
  api.setStatusVisibility,
  SET_STATUS_VISIBILITY[START],
  SET_STATUS_VISIBILITY[SUCCESS],
  SET_STATUS_VISIBILITY[ERROR],
);
